import React, { useState } from 'react';
import styled from 'styled-components';
import Grid from '@ntuctech/devex-tangram/Grid';
import moment from 'moment';
import { SCREEN_SIZE } from '../../lib/mediaQuery';
import { numberFormat } from '../../lib/utils';
import { DEFAULT_TITLE } from '../../constants';

const TransactionsSection = styled.div`
  ${SCREEN_SIZE.Only.Mobile} {
    .tabletView {
      display: block;
    }
  }
  ${SCREEN_SIZE.From.MobileL} {
    .desktopView {
      display: block;
    }
  }
  ${SCREEN_SIZE.From.Tablet} {
    .tabletView {
      display: block;
    }
  }
  ${SCREEN_SIZE.From.Desktop} {
    .desktopView {
      display: block;
    }
  }
  width: 100%;
  background: #f6f6f6;
  padding: 30px 15px;
  margin-top: 40px;
  h3 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    color: #333333;
  }
  p {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #666666;
  }
  h6 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #333333;
    position: relative;
    top: 5px;
  }
  h5 {
    font-family: 'Lato', serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    text-align: right;
    color: #333333;
  }
`;
const TransactionsList = styled.li`
  border-bottom: 1px solid #eaeaea;
  padding: 20px 0;
  :nth-last-child(1) {
    border-bottom: none;
  }
  > div:nth-child(1) > div > div:nth-last-child(1) {
    justify-content: end;
    align-items: center;
    display: flex;
  }
`;

const SeeAllBtn = styled.a`
  font-family: 'Lato', serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: right;
  color: #1557bf;
  text-decoration: none;
  @media screen and (max-width: 767px) {
    padding-left: 18px;
  }
`;
const RmvInnerPad = styled.div`
  ${SCREEN_SIZE.From.Tablet} {
    > div:nth-child(1) {
      padding: 0 0;
    }
    > div:nth-child(1) > div:nth-child(1) {
      padding-left: 0;
    }
    > div:nth-child(1) > div:nth-last-child(1) {
      padding-right: 0;
    }
  }
`;
const TabletViewText = styled.h6`
  font-family: 'Lato', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
`;

const Transactions = (props) => {
  const [showAll, setShowAll] = useState(false);
  const { transactions } = props;

  // Function to toggle showAll state
  const handleSeeAllClick = () => {
    setShowAll((prev) => !prev);
  };

  if (transactions?.length === 0) {
    return (
      <TransactionsSection>
        <h3>{DEFAULT_TITLE} transactions</h3>
        <div className="tabletView">
          <TabletViewText>
            Start using your E-Gift Voucher. Your redemptions will be shown here.
          </TabletViewText>
        </div>
      </TransactionsSection>
    );
  }

  return (
    <TransactionsSection>
      <h3>{DEFAULT_TITLE} transactions</h3>
      <div className="desktopView">
        <ul>
          {(showAll ? transactions : transactions.slice(0, 3)).map((transaction) => {
            const isRefund = transaction.type === 'REFUND';
            return (
              <TransactionsList>
                <RmvInnerPad>
                  <Grid container key={transaction.storeName}>
                    <Grid item xs={8}>
                      <p>{moment(transaction.updatedAt).format('Do MMM YYYY hh.mma')}</p>
                      <h6>{`${transaction.storeName} ${isRefund ? '(Refund)' : ''}`}</h6>
                    </Grid>
                    <Grid item xs={4}>
                      <h5>{`${isRefund ? '+' : '-'}${numberFormat(transaction.amount)}`}</h5>
                    </Grid>
                  </Grid>
                </RmvInnerPad>
              </TransactionsList>
            );
          })}
        </ul>
        {transactions?.length > 3 && !showAll && (
          <SeeAllBtn data-testid="see-all-btn" onClick={() => handleSeeAllClick()}>
            See all
          </SeeAllBtn>
        )}
      </div>
    </TransactionsSection>
  );
};

export default Transactions;
